import * as React from "react";
import { FormattedMessage, FormattedDate } from "react-intl";
import Typography from "components/Typography";
import Switch from "components/Switch";
import * as styles from "./styles";

interface IProps {
  text: string;
  expiry?: string;
  consented: boolean;
  patching: boolean;
  onChange: (value: boolean) => void;
}

const Consent: React.FC<IProps> = ({ text, expiry, consented, patching, onChange }) => (
  <div className={styles.consent}>
    <div className={styles.row}>
      <div className={styles.text}>
        <Typography>{text}</Typography>
      </div>
      <Switch state={consented} loading={patching} onChange={onChange} />
    </div>
    {expiry && (
      <div className={styles.expiry}>
        <Typography color="grey">
          <FormattedMessage
            id="components.Consent.expiry"
            values={{
              date: <FormattedDate value={expiry} year="numeric" month="long" day="numeric" />,
            }}
          />
        </Typography>
      </div>
    )}
  </div>
);

export default Consent;
